<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
  <g id="Group_3147" data-name="Group 3147" transform="translate(-1167 -4110)">
    <rect id="Rectangle" width="48" height="48" rx="1.714" transform="translate(1167 4110)" fill="#e7ebff"/>
    <g id="Group_3146" data-name="Group 3146" transform="translate(-0.016)">
      <path id="Path" d="M8,0A8,8,0,0,0,.96,11.8l6.6,11.94a.5.5,0,0,0,.875,0l6.6-11.944A8,8,0,0,0,8,0Z" transform="translate(1183.016 4122)" fill="#4562ff"/>
      <path id="Path-2" data-name="Path" d="M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8Z" transform="translate(1187.016 4126)" fill="#e7ebff"/>
    </g>
  </g>
</svg>
